import React from "react";
import {components} from "react-select";

export default function CustomOptionWithGtm(props) {
  return (
    <components.Option {...props}>
      <div data-gtm-event-region={props.gtmEventRegion} data-gtm-event-element={props.gtmEventElement}>
        {props.data.label}
      </div>
    </components.Option>
  );
}